import { MachineActions } from 'common/bento/types/MachineConfig';
import webView from 'common/webView';
import { logEvent } from 'features/Analytics/analytics';
import {
  getPlanType,
  isValidPlanId,
} from 'features/Onboarding/common/planUtils';
import researchExperimentStorage from 'features/Onboarding/modules/ResearchExperiment/storage/researchExperiment';
import { ApplicationType } from 'features/Onboarding/types';
import logger from 'helpers/logger';
import { PlanType } from 'types/planUtils';

import { Model } from './model';

export enum Action {
  LogUnexpectedState = 'logUnexpectedState',
  TrackCustomerAcquisitionCompleted = 'trackCustomerAcquisitionCompleted',
  SaveResearchExperimentSeen = 'saveResearchExperimentSeen',
  TriggerOnboardingCompletedMessage = 'triggerOnboardingCompletedMessage',
}

const actions: MachineActions<Model, Action> = {
  logUnexpectedState: () => {
    logger.error(`Unexpected state for this standard application`);
  },

  saveResearchExperimentSeen: () => {
    researchExperimentStorage.set();
  },

  trackCustomerAcquisitionCompleted: ({ getModuleData }) => {
    const { companyData } = getModuleData();
    const selectedPlanId = companyData?.company.metadata.selectedPlanId;
    let plan: PlanType | null = null;

    if (
      selectedPlanId !== undefined &&
      selectedPlanId !== null &&
      isValidPlanId(selectedPlanId)
    ) {
      plan = getPlanType(selectedPlanId);
    }

    logEvent({
      name: 'Customer Acquisition Completed',
      properties: {
        accountType: ApplicationType.Standard,
        plan, // We let the plan the opportunity to be null or a valid plan type, but nothing else
      },
      usePrefix: false,
    });
  },

  triggerOnboardingCompletedMessage: ({ getModuleData }) => {
    const { companyProfileId = '', companyUserId = '' } =
      getModuleData().companyContext;

    return webView.postMessage({
      action: 'ONBOARDING_COMPLETED',
      payload: { companyProfileId, companyUserId },
    });
  },
};

export default actions;
